import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const KnockoutQuestionsSection = ({ dealInterest }) => {
  const intl = useIntl();
  if (!dealInterest) {
    return null;
  }

  // Build array of Q&A pairs that have answers
  const questions = [
    { key: 'a1', label: dealInterest.q1, value: dealInterest.a1 },
    { key: 'a2', label: dealInterest.q2, value: dealInterest.a2 },
    { key: 'a3', label: dealInterest.q3, value: dealInterest.a3 },
    { key: 'a4', label: dealInterest.q4, value: dealInterest.a4 },
    { key: 'a5', label: dealInterest.q5, value: dealInterest.a5 }
  ].filter(q => q.value && q.value.trim() !== '');

  if (questions.length === 0) {
    return null;
  }

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-succession-border">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <svg className="w-6 h-6 text-succession-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-succession-text-primary">
              {intl.formatMessage({ id: 'succession.profile_drawer.knockout_questions_section.screening_questions_title' })}
            </h3>
            <p className="text-sm text-succession-text-muted mt-1">
              {intl.formatMessage({ id: 'succession.profile_drawer.knockout_questions_section.screening_questions_subtitle' })}
            </p>
          </div>
        </div>
      </div>

      {/* Questions List */}
      <div className="px-6 py-4">
        <div className="space-y-6">
          {questions.map((question, index) => (
            <div key={question.key} className="border-b border-succession-border pb-6 last:border-b-0 last:pb-0">
              <div className="flex items-start gap-3">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-succession-primary/10 text-succession-primary text-sm font-medium flex-shrink-0 mt-1">
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-succession-text-primary mb-3">
                    {question.label}
                  </h4>
                  <div className="text-sm text-succession-text-primary bg-succession-bg-primary rounded-lg p-4 whitespace-pre-wrap border border-succession-border">
                    {question.value}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-3 bg-succession-bg-primary border-t border-succession-border">
        <div className="flex items-center text-xs text-succession-text-muted">
          <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {questions.length !== 1
            ? intl.formatMessage({ id: 'succession.profile_drawer.knockout_questions_section.answered_count_plural' }, { count: questions.length })
            : intl.formatMessage({ id: 'succession.profile_drawer.knockout_questions_section.answered_count' }, { count: questions.length })}
        </div>
      </div>
    </div>
  );
};

KnockoutQuestionsSection.propTypes = {
  dealInterest: PropTypes.shape({
    q1: PropTypes.string,
    q2: PropTypes.string,
    q3: PropTypes.string,
    q4: PropTypes.string,
    q5: PropTypes.string,
    a1: PropTypes.string,
    a2: PropTypes.string,
    a3: PropTypes.string,
    a4: PropTypes.string,
    a5: PropTypes.string,
  }),
};

export default KnockoutQuestionsSection;

